// src/ConveGroupList.tsx

import React from 'react';
import { GroupRoom } from './types/groupChat';

interface Props {
  rooms: GroupRoom[];
  activeRoomId: number | null;
  onSelectRoom: (roomId: number) => void;
  onNewChat: () => void;
  isOnline: (userId: number) => boolean;
}

function formatTime(dateStr: string | null): string {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  if (days === 0) {
    return date.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' });
  } else if (days < 7) {
    return date.toLocaleDateString('ko-KR', { weekday: 'short' });
  }
  return date.toLocaleDateString('ko-KR', { month: 'short', day: 'numeric' });
}

function getRoomIcon(room: GroupRoom): string {
  if (room.memberCount <= 2) return '💬';
  return '👥';
}

const ConveGroupList: React.FC<Props> = ({
  rooms,
  activeRoomId,
  onSelectRoom,
  onNewChat,
}) => {
  return (
    <div className="conve-group-list">
      <div className="conve-sb-actions">
        <button className="conve-new-btn" onClick={onNewChat}>
          <span className="conve-plus-circle">+</span>
          새 대화
        </button>
      </div>

      <div className="conve-sb-section-label">대화 목록</div>

      <div className="conve-chat-list">
        {rooms.length === 0 ? (
          <div className="conve-rooms-empty">대화 내역이 없습니다</div>
        ) : (
          rooms.map((room) => (
            <div
              key={room.id}
              className={`conve-chat-item conve-group-item ${room.id === activeRoomId ? 'active' : ''}`}
              onClick={() => onSelectRoom(room.id)}
            >
              <div className="conve-group-icon">{getRoomIcon(room)}</div>
              <div className="conve-group-info">
                <div className="conve-group-header">
                  <span className="conve-group-title">{room.title}</span>
                  <span className="conve-group-time">{formatTime(room.lastMessageAt)}</span>
                </div>
                <div className="conve-group-footer">
                  <span className="conve-group-last-msg">
                    {room.lastMessage
                      ? room.lastMessage.length > 20
                        ? room.lastMessage.slice(0, 20) + '...'
                        : room.lastMessage
                      : '대화를 시작해보세요'}
                  </span>
                  <div className="conve-group-badges">
                    {room.onlineCount > 0 && (
                      <span className="conve-online-badge">{room.onlineCount}명 온라인</span>
                    )}
                    {room.unreadMessageCount > 0 && (
                      <span className="conve-unread-badge">{room.unreadMessageCount}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ConveGroupList;
